export const getLastMonth = () => {
    const today = new Date();
    const lastMonth = new Date();
  
    lastMonth.setDate(today.getDate() - 30);
    return {
      startDate: lastMonth.toISOString().split("T")[0],
      endDate: today.toISOString().split("T")[0],
    };
  };
  